import { STATUS_LABELS, STATUS_TONES, type RascunhoStatus } from "@/types/editor-territorial";

const TONE_CLASSES: Record<string, string> = {
  neutral: "bg-background-100 text-foreground-600",
  info: "bg-blue-100 text-blue-700",
  success: "bg-green-100 text-green-700",
  warning: "bg-caution-100 text-caution-700",
  danger: "bg-danger-100 text-danger-700",
};

export default function StatusBadge({ status }: { status: string }) {
  const key = (status as RascunhoStatus) in STATUS_LABELS ? (status as RascunhoStatus) : "RASCUNHO";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${TONE_CLASSES[STATUS_TONES[key]]}`}>
      {STATUS_LABELS[key]}
    </span>
  );
}
